import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useSemanticModelByEnvironment } from '../discovery/semanticModel';
import { useEnvironmentScope } from '../useEnvironmentScope';

export type SemanticModelResult = ReturnType<typeof useSemanticModel>['data'];

export const useSemanticModel = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useSemanticModelByEnvironment({
    environmentId: validEnvironmentId,
    uniqueId: uniqueId?.raw ?? '',
    userId,
    pause: uniqueId?.resourceType !== 'semantic_model' || userId === 'loading',
  });

  const semanticModelQuery = useMemo(() => {
    const definitionEdge = data?.environment.definition?.semanticModels.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: undefined, definition: definitionEdge?.node },
    };
  }, [fetching, error, data]);

  return semanticModelQuery;
};
